import type { EmptyStateContent } from "../types-carga-de-trabalho";

/** Dica do "Agrupar por" (Figma: tooltip · Visualizar por). */
export const GROUPING_HINT = "Muda como as informações são organizadas: por Local ou por obra.";

/** Legenda da perspectiva Local (Figma): Obra e Cancelada; o "Hoje" é da própria legenda. */
export const LEGEND: { key: string; label: string }[] = [
  { key: "obra", label: "Obra" },
  { key: "cancelada", label: "Cancelada" },
];

export const VAZIO_SEM_ALOCACAO: EmptyStateContent = {
  title: "Nenhuma alocação encontrada",
  description: "Não há obras alocadas no período selecionado.",
};
